"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2Accordion = void 0;
var bc_accordion_constants_1 = require("../../../molecules/bc-accordion/bc-accordion-constants");
var common_constants_1 = require("../../../../common/constants/common-constants");
var helpers_1 = require("../../../../common/helpers");
var bc_menu_v2_constants_1 = require("../bc-menu-v2-constants");
var BcMenuV2Accordion = (function () {
    function BcMenuV2Accordion(listItemsMenuArr, index, ulElement, closePopOvers, isTablet) {
        this.listItemsMenuArr = listItemsMenuArr;
        this.index = index;
        this.ulElement = ulElement;
        this.closePopOvers = closePopOvers;
        this.isTablet = isTablet;
        this.render();
    }
    BcMenuV2Accordion.prototype.render = function () {
        this.createAcordionItemMore(this.listItemsMenuArr, this.index, this.ulElement);
    };
    BcMenuV2Accordion.prototype.createAcordionItemMore = function (listItemsMenuArr, index, ulElement) {
        var _this = this;
        var liElement = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.LI_TAG,
        });
        var mainDivAcordion = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDIONS_GROUPS_SUFIX, bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_SINGLE_CLASS],
            props: { role: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_GROUP, id: "accordionID".concat(index) },
        });
        var item = listItemsMenuArr[index];
        var isDisabled = item.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_DISABLED);
        var itemAMegaMenu = item.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        var arrGroups = itemAMegaMenu.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_GROUPS));
        var arrGroupsClone = [];
        arrGroups.forEach(function (group) { arrGroupsClone.push(group.cloneNode(true)); });
        arrGroupsClone.forEach(function (group) {
            group.querySelectorAll(".bc-link").forEach(function (link) {
                link.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                    var returnEvent = _this.getReturnEventAcordion(link);
                    _this.onEventResponsive(returnEvent, event);
                    _this.closePopOvers();
                    _this.onDeleteClassActiveItems();
                    _this.onDeleteClassPressItems();
                    var liItem = document.getElementById(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ITEM_MORE).querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
                    liItem.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
                });
            });
        });
        var em = item.querySelector(common_constants_1.BcCommonConstants.EM_TAG).textContent;
        var span = item.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).textContent;
        var article = this.createAcordeon(arrGroupsClone, index, span, em, isDisabled);
        mainDivAcordion.appendChild(article);
        liElement.appendChild(mainDivAcordion);
        ulElement.appendChild(liElement);
    };
    BcMenuV2Accordion.prototype.getReturnEventAcordion = function (link) {
        var textLink = link.querySelector('span').innerText;
        var titleGroup = link
            .closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP))
            .getAttribute('title');
        var titleItem = link
            .closest('.bc-accordion-content')
            .previousElementSibling.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE)).innerHTML;
        return {
            titleGroup: titleGroup,
            titleItem: titleItem,
            textLink: textLink,
        };
    };
    BcMenuV2Accordion.prototype.createAcordeon = function (groups, index, title, iconTitle, isDisabled) {
        var _a, _b;
        var article = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.ARTICLE_TAG,
            classList: [bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_CLASS, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_MINIMAL_UNBORDERED],
            props: { id: "idHeader".concat(index) },
        });
        var header = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.HEADER_TAG,
            props: (_a = {},
                _a[common_constants_1.BcCommonConstants.ARIA_EXPANDED] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE,
                _a[common_constants_1.BcCommonConstants.ARIA_CONTROL] = "idHeader".concat(index),
                _a.id = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_WITHOUT_HEADER,
                _a[bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ARIA] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE_SUPER_BASIC,
                _a),
        });
        if (isDisabled) {
            header.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_DISABLED);
        }
        var titleH6 = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.H6_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE],
            props: { id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TITLE_SUPER_BASIC },
            innerText: title,
        });
        var container = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_CONTENT_CLASS],
            props: (_b = { role: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_REGION }, _b[bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ARIA] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_WITHOUT_HEADER, _b),
        });
        this.configAcordeonConstants(header, iconTitle, titleH6, container, article);
        groups.forEach(function (group) {
            container.appendChild(group);
        });
        article.style.boxShadow = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_BOX_SHADOW_ACCORDION;
        return article;
    };
    BcMenuV2Accordion.prototype.configAcordeonConstants = function (sectionHeader, titleElement, h6Element, containerElement, articleElement) {
        var _a, _b;
        var icon = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TOGGLE],
            props: (_a = { alt: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_ALT }, _a[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE, _a),
            innerText: common_constants_1.BcCommonConstants.ICON_ARROW_DOWN,
        });
        var emIcon = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
            props: (_b = {}, _b[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE, _b),
            innerText: titleElement,
        });
        var arrow = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_HEADER_RIGHT],
        });
        var sectionHeaderTextContainer = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_TEXT_CONTAINER],
        });
        var sectionHeaderleft = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ACCORDION_HEADER_LEFT],
        });
        arrow.appendChild(icon);
        sectionHeader.appendChild(sectionHeaderleft);
        sectionHeader.appendChild(arrow);
        sectionHeaderleft.appendChild(emIcon);
        sectionHeaderTextContainer.appendChild(h6Element);
        sectionHeaderleft.appendChild(sectionHeaderTextContainer);
        this.configAcordeonItems(sectionHeader, containerElement, articleElement);
    };
    BcMenuV2Accordion.prototype.configAcordeonItems = function (sectionHeader, containerElement, articleElement) {
        containerElement.style.margin = this.isTablet
            ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_MARGIN_TABLET
            : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N0;
        containerElement.style.overflow = common_constants_1.BcCommonConstants.HIDDEN;
        articleElement.appendChild(sectionHeader);
        articleElement.appendChild(containerElement);
    };
    return BcMenuV2Accordion;
}());
exports.BcMenuV2Accordion = BcMenuV2Accordion;
